import { createRouter, createWebHistory } from "vue-router";

const routes = [
  
  { 
    path: '/index.html', 
    redirect: '/home' ,
   },
  { 
    path: '/', 
    redirect: '/home' ,
   },
   { 
    path: "/hello",
    name: "hello",
    component: () => import("../components/HelloWorld.vue"),
   },
   { 
    path: "/profile",
    name: "profile",
    component: () => import("../components/Profile.vue"),
   },
  {
    path: "/home",
    name: "Home",
    component: () => import("../components/Home.vue"),
  },
{
    path: "/TakePhotos",
    name: "TakePhotos",
    component: () => import("../components/TakePhotos.vue"),
  },
  {
    path: "/TakePhotos2",
    name: "TakePhotos2",
    component: () => import("../components/TakePhotos2.vue"),
  },
 {
    path: "/TakePhotos3",
    name: "TakePhotos3",
    component: () => import("../components/TakePhotos3.vue"),
  },
{
    path: "/TakePhotos4",
    name: "TakePhotos4",
    component: () => import("../components/TakePhotos4.vue"),
  },
{
    path: "/TakePhotos5",
    name: "TakePhotos5",
    component: () => import("../components/TakePhotos5.vue"),
  },


 {
    path: "/TakePhotosQRCode",
    name: "TakePhotosQRCode",
    component: () => import("../components/TakePhotosQRCode.vue"),
  },
 
  
//Flow 審核 *************************************************************
  {
    path: "/flowList",
    name: "FlowList",
    meta: {
      title: 'FlowList',
      requiresAuth: true,
      is_compalUser: true
      
    },
    component: () => import("../components/FlowList.vue"),
},
{
  path: "/flowListFinish",
  name: "FlowListFinish",
  meta: {
    title: 'FlowList',
    requiresAuth: true,
    is_compalUser: true
    
  },
  component: () => import("../components/FlowListFinish.vue"),
},
{
  path: "/flowListProcessing",
  name: "FlowListProcessing",
  meta: {
    title: 'FlowList',
    requiresAuth: true,
    is_compalUser: true
    
  },
  component: () => import("../components/FlowListProcessing.vue"),
},

 

{
  path: "/flow/:id",
  name: "Flow",
  props: true,
  meta: {
    title: 'Flow',
    requiresAuth: true,
    is_compalUser: true
  },
  component: () => import("../components/Flow.vue"),
},
//Sourcer *************************************************************
{
    path: "/sourcerApplyList",
    name: "SourcerApplyList",
    meta: {
      title: 'SourcerApplyList',
      requiresAuth: true,
      is_source: true
    },
    component: () => import("../components/SourcerApplyList.vue"),
},

{
    path: "/SourcerQueryVendorCode4",
    name: "SourcerQueryVendorCode4",
    meta: {
      title: 'SourcerQueryVendorCode4',
      requiresAuth: true,
      is_source: true
    },
    component: () => import("../components/SourcerQueryVendorCode4.vue"),
},

{
  path: "/sourcerNewApplyType1",
  name: "SourcerNewApplyType1",
  meta: {
    title: 'SourcerApplyType1',
    requiresAuth: true,
    is_source: true
  },
  component: () => import("../components/SourcerApplyType1.vue"),
},
//Sourcer 開啟 申請頁面 Supervisor
{
path: "/sourcerApplyType1/:id",
name: "SourcerApplyType1",
props: true,
meta: {
  title: 'SourcerApplyType1',
  requiresAuth: true,
  is_source: true
},
component: () => import("../components/SourcerApplyType1.vue"),
},
{
  path: "/sourcerApplyType6/:id",
  name: "SourcerApplyType6",
  meta: {
    title: 'SourcerApplyType6',
    requiresAuth: true,
    is_source: true
  },
  component: () => import("../components/SourcerApplyType6.vue"),
},
{
  path: "/sourcerSupervisorList",
  name: "SourcerSupervisorList",
  meta: {
    title: 'SourcerSupervisorList',
    requiresAuth: true,
    is_source: true
  },
  component: () => import("../components/SourcerSupervisorList.vue"),
},
{
  path: "/sourcerSearchSupervisorAndUserList",
  name: "SourcerSearchSupervisorAndUserList",
  meta: {
    title: 'SourcerSearchSupervisorAndUserList',
    requiresAuth: true,
    is_source: true
  },
  component: () => import("../components/SourcerSearchSupervisorAndUserList.vue"),
},
{
  path: "/sourcerApplyType7",
  name: "SourcerApplyType7",
  meta: {
    title: 'SourcerApplyType7',
    requiresAuth: true,
    is_source: true
  },
  component: () => import("../components/SourcerApplyType7.vue"),
},





{
  path: "/sourcerCancelMFGCode",
  name: "SourcerCancelMFGCode",
  meta: {
    title: 'SourcerCancelMFGCode',
    requiresAuth: true,
    is_source: true
  },
  component: () => import("../components/SourcerCancelMFGCode.vue"),
},
{
  path: "/sourcerUpdateShortName",
  name: "SourcerUpdateShortName",
  meta: {
    title: 'SourcerUpdateShortName',
    requiresAuth: true,
    is_source: true
  },
  component: () => import("../components/SourcerUpdateShortName.vue"),
},
 


//Supervisor *************************************************************

{
  path: "/SupervisorQueryVendorCode4",
  name: "SupervisorQueryVendorCode4",
  meta: {
    title: 'SupervisorQueryVendorCode4',
    requiresAuth: true,
    is_supervisor: true
  },
  component: () => import("../components/SupervisorQueryVendorCode4.vue"),
},

{
  path: "/SupervisorVendorCode4ChangeDataView/:id",
  name: "SupervisorVendorCode4ChangeDataView",
  meta: {
    title: 'SupervisorVendorCode4ChangeDataView',
    requiresAuth: true,
    is_supervisor: true
  },
  component: () => import("../components/SupervisorVendorCode4ChangeDataView.vue"),
},
{
  path: "/SupervisorVendorCode4ChangeDataView/:id",
  name: "SupervisorVendorCode4ChangeDataView",
  meta: {
    title: 'SupervisorVendorCode4ChangeDataView',
  },
  component: () => import("../components/SupervisorVendorCode4ChangeDataView.vue"),
},
{
  path: "/NewVendorCode4ChangeData/:id",
  name: "NewVendorCode4ChangeData",
  meta: {
    title: 'SupervisorVendorCode4ChangeData',
    requiresAuth: true,
    is_supervisor: true
  },
  component: () => import("../components/SupervisorVendorCode4ChangeData.vue"),
},
{
  path: "/SupervisorVendorCode4ChangeData",
  name: "SupervisorVendorCode4ChangeData",
  meta: {
    title: 'SupervisorVendorCode4ChangeData',
    requiresAuth: true,
    is_supervisor: true
  },
  component: () => import("../components/SupervisorVendorCode4ChangeData.vue"),
},
{
  path: "/SupervisorVendorCode4",
  name: "SupervisorVendorCode4",
  meta: {
    title: 'SupervisorVendorCode4',
    requiresAuth: true,
    is_supervisor: true
  },
  component: () => import("../components/SupervisorVendorCode4.vue"),
},

{
  path: "/supervisorApplyList",
  name: "SupervisorApplyList",
  meta: {
    title: 'SupervisorApplyList',
    requiresAuth: true,
    is_supervisor: true
  },
  component: () => import("../components/SupervisorApplyList.vue"),
},
//Supervisor 新申請 User
{
  path: "/SupervisorNewApplyType2",
  name: "SupervisorNewApplyType2",
  meta: {
    title: 'SupervisorApplyType2',
    requiresAuth: true,
    is_supervisor: true
  },
  component: () => import("../components/SupervisorApplyType2.vue"),
},
//Supervisor 開啟 申請頁面 User
{
  path: "/supervisorApplyType2/:id",
  name: "SupervisorApplyType2",
  props: true,
  meta: {
    title: 'SupervisorApplyType2',
    requiresAuth: true,
    is_supervisor: true
  },
  component: () => import("../components/SupervisorApplyType2.vue"),
},
{
  path: "/supervisorApplyType3",
  name: "SupervisorApplyType3",
  meta: {
    title: 'SupervisorApplyType3',
    requiresAuth: true,
    is_supervisor: true
  },
  component: () => import("../components/SupervisorApplyType3.vue"),
},
{
  path: "/supervisorApplyType4",
  name: "SupervisorApplyType4",
  meta: {
    title: 'SupervisorApplyType4',
    requiresAuth: true,
    is_supervisor: true
  },
  component: () => import("../components/SupervisorApplyType4.vue"),
},
{
  path: "/supervisorApplyType6/:id",
  name: "SupervisorApplyType6",
  meta: {
    title: 'SupervisorApplyType6',
    requiresAuth: true,
    is_supervisor: true
  },
  component: () => import("../components/SupervisorApplyType6.vue"),
},


{
  path: "/supervisorApplyType5",
  name: "SupervisorApplyType5",
  meta: {
    title: 'SupervisorApplyType5',
    requiresAuth: true,
    is_supervisor: true
    
  },
  component: () => import("../components/SupervisorApplyType5.vue"),
},
{
  path: "/supervisorUpdateInformation",
  name: "SupervisorUpdateInformation",
  meta: {
    title: 'SupervisorUpdateInformation',
    requiresAuth: true,
    is_supervisor: true
    
  },
  component: () => import("../components/SupervisorUpdateInformation.vue"),
},
{
  path: "/supervisorUserList",
  name: "SupervisorUserList",
  meta: {
    title: 'SupervisorUserList',
    requiresAuth: true,
    is_supervisor: true
    
  },
  component: () => import("../components/SupervisorUserList.vue"),
},
{
  path: "/supervisorViewApply/:id",
  name: "SupervisorViewApply",
  meta: {
    title: 'SupervisorViewApply',
    requiresAuth: true,
    is_supervisor: true
    
  },
  component: () => import("../components/SupervisorViewApply.vue"),
},



//**Admin************************************************************************
{
  path: "/adminFestivalList",
  name: "AdminFestivalList",
  meta: {
    title: 'AdminFestivalList',
    requiresAuth: true,
    is_admin: true
    
  },
  component: () => import("../components/AdminFestivalList.vue"),
},
//**Admin************************************************************************
{
  path: "/adminMaillogList",
  name: "AdminMaillogList",
  meta: {
    title: 'AdminMaillogList',
    requiresAuth: true,
    is_admin: true
    
  },
  component: () => import("../components/AdminMaillogList.vue"),
},
{
  path: "/adminApplyType8",
  name: "AdminApplyType8",
  meta: {
    title: 'AdminApplyType8',
    requiresAuth: true,
    is_admin: true
    
  },
  component: () => import("../components/AdminApplyType8.vue"),
},
{
  path: "/adminUpdateSupervisorSAPSearchTerm",
  name: "AdminUpdateSupervisorSAPSearchTerm",
  meta: {
    title: 'AdminUpdateSupervisorSAPSearchTerm',
    requiresAuth: true,
    is_admin: true
    
  },
  component: () => import("../components/AdminUpdateSupervisorSAPSearchTerm.vue"),
},




{
  path: "/adminMaillog/:id",
  name: "AdminMaillog",
  meta: {
    title: 'AdminMaillog',
    requiresAuth: true,
    is_admin: true
    
  },
  component: () => import("../components/AdminMaillog.vue"),
},

{
  path: "/adminNewFestival",
  name: "AdminNewFestival",
  meta: {
    title: 'AdminFestival',
    requiresAuth: true,
    is_admin: true
    
  },
  component: () => import("../components/AdminFestival.vue"),
},
{
  path: "/adminFestival/:id",
  name: "AdminFestival",
  meta: {
    title: 'AdminFestival',
    requiresAuth: true,
    is_admin: true
    
  },
  component: () => import("../components/AdminFestival.vue"),
},

{
  path: "/adminSystemList",
  name: "AdminSystemList",
  meta: {
    title: 'AdminSystemList',
    requiresAuth: true,
    is_admin: true
    
  },
  component: () => import("../components/AdminSystemList.vue"),
},
{
  path: "/adminNewSystemRelease",
  name: "AdminNewSystemRelease",
  meta: {
    title: 'AdminSystemRelease',
    requiresAuth: true,
    is_admin: true
    
  },
  component: () => import("../components/AdminSystemRelease.vue"),
},
{
  path: "/adminSystemRelease/:id",
  name: "AdminSystemRelease",
  meta: {
    title: 'AdminSystemRelease',
    requiresAuth: true,
    is_admin: true
    
  },
  component: () => import("../components/AdminSystemRelease.vue"),
},
{
  path: "/adminBulletinMaintain",
  name: "AdminBulletinMaintain",
  props: true,
  meta: {
    title: 'AdminBulletinMaintain',
    requiresAuth: true,
    is_admin: true,
    is_scsi:true
  },
  component: () => import("../components/AdminBulletinMaintain.vue"),      
},
{
  path: "/adminUpdateType",
  name: "AdminUpdateType",
  props: true,
  meta: {
    title: 'AdminUpdateType',
    requiresAuth: true,
    is_admin: true,
    is_scsi:true
  },
  component: () => import("../components/AdminUpdateType.vue"),      
},





//******SCSI********************************************************************

{
  path: "/SCSIQueryVendorCode4",
  name: "SCSIQueryVendorCode4",
  props: true,
  meta: {
    title: 'SCSIQueryVendorCode4',
    requiresAuth: true,
    is_scsi:true
  },
  component: () => import("../components/SCSIQueryVendorCode4.vue"),      
},
{
  path: "/scsiAudit",
  name: "SCSIAudit",
  props: true,
  meta: {
    title: 'SCSIAudit',
    requiresAuth: true,
    is_scsi:true
  },
  component: () => import("../components/SCSIAudit.vue"),      
},
{
  path: "/scsiBatchDelete",
  name: "SCSIBatchDelete",
  props: true,
  meta: {
    title: 'SCSIBatchDelete',
    requiresAuth: true,
    is_scsi:true
  },
  component: () => import("../components/SCSIBatchDelete.vue"),      
},
{
  path: "/scsiChangeSourcer",
  name: "SCSIChangeSourcer",
  props: true,
  meta: {
    title: 'SCSIChangeSourcer',
    requiresAuth: true,
    is_scsi:true
  },
  component: () => import("../components/SCSIChangeSourcer.vue"),      
},
{
  path: "/scsiSearchSupervisorAndUserList",
  name: "SCSISearchSupervisorAndUserList",
  props: true,
  meta: {
    title: 'SCSISearchSupervisorAndUserList',
    requiresAuth: true,
    is_scsi:true
  },
  component: () => import("../components/SCSISearchSupervisorAndUserList.vue"),      
},
{
  path: "/scsiSearchApplyFlowProcessing",
  name: "SCSISearchApplyFlowProcessing",
  props: true,
  meta: {
    title: 'SCSISearchApplyFlowProcessing',
    requiresAuth: true,
    is_scsi:true
  },
  component: () => import("../components/SCSISearchApplyFlowProcessing.vue"),      
},




{
  path: "/adminSearchSupervisorAndUserList",
  name: "AdminSearchSupervisorAndUserList",
  props: true,
  meta: {
    title: 'AdminSearchSupervisorAndUserList',
    requiresAuth: true,
    is_admin:true
  },
  component: () => import("../components/AdminSearchSupervisorAndUserList.vue"),      
},



{
  path: "/scsiSyncSAPVendorCode",
  name: "SCSISyncSAPVendorCode",
  props: true,
  meta: {
    title: 'SCSISyncSAPVendorCode',
    requiresAuth: true,
    is_scsi:true
  },
  component: () => import("../components/SCSISyncSAPVendorCode.vue"),      
},
{
  path: "/flowChangeSignADList",
  name: "FlowChangeSignADList",
  props: true,
  meta: {
    title: 'FlowChangeSignADList',
    requiresAuth: true,
    is_scsi:true,
    is_admin:true,
  },
  component: () => import("../components/FlowChangeSignADList.vue"),      
},




  //*******for All *******************************************************************
  

  {
    path: "/buyerSearchSupervisorAndUserList",
    name: "BuyerSearchSupervisorAndUserList",
    props: true,
    meta: {
      title: 'BuyerSearchSupervisorAndUserList',
      requiresAuth: true,
      is_compalUser: true
     
    },
    component: () => import("../components/BuyerSearchSupervisorAndUserList.vue"),      
},

  {
    path: "/bulletinView/:id",
    name: "bulletinView",
    props: true,
    meta: {
      title: 'BulletinView',
      requiresAuth: true,
      is_compalUser: true,
      is_vendorUser: true
     
    },
    component: () => import("../components/BulletinView.vue"),      
},
{
  path: "/newBulletin",
  name: "NewBulletin",
  props: true,
  meta: {
    title: 'Bulletin',
    requiresAuth: true,
    is_compalUser: true,
    is_vendorUser: true
   
  },
  component: () => import("../components/Bulletin.vue"),      
},
{
  path: "/bulletinMaintain/:id",
  name: "BulletinMaintain",
  props: true,
  meta: {
    title: 'AdminBulletinMaintain',
    requiresAuth: true,
    is_admin: true,
    is_scsi:true
    
   
  },
  component: () => import("../components/AdminBulletinMaintain.vue"),      
},
{
  path: "/bulletinPrevView",
  name: "BulletinPrevView",
  props: true,
  meta: {
    title: 'BulletinPrevView',
    requiresAuth: true,
    is_admin: true,
    is_scsi:true
   
  },
  component: () => import("../components/BulletinPrevView.vue"),      
},




{
  path: "/bulletinAll",
  name: "BulletinAll",
  props: true,
  meta: {
    title: 'BulletinAll',
    requiresAuth: true,
    is_compalUser: true,
    is_vendorUser: true
   
  },
  component: () => import("../components/BulletinAll.vue"),      
},
{
  path: "/bulletinEditAll",
  name: "BulletinEditAll",
  props: true,
  meta: {
    title: 'BulletinEditAll',
    requiresAuth: true,
    is_admin: true,
    is_scsi:true
  },
  component: () => import("../components/BulletinEditAll.vue"),      
},


{
  path: "/userManualUpload",
  name: "UserManualUpload",
  props: true,
  meta: {
    title: 'UserManualUpload',
    requiresAuth: true,
    is_admin: true,
    is_scsi:true
  },
  component: () => import("../components/UserManualUpload.vue"),      
},
{
  path: "/userManualUploadEdit/:id",
  name: "UserManualUploadEdit",
  props: true,
  meta: {
    title: 'UserManualUploadEdit',
    requiresAuth: true,
    is_admin: true,
    is_scsi:true
  },
  component: () => import("../components/UserManualUploadEdit.vue"),      
},
{
  path: "/userManualList",
  name: "UserManualList",
  props: true,
  meta: {
    title: 'UserManualList',
    requiresAuth: true,
    is_compalUser: true,
    is_vendorUser: true
   
  },
  component: () => import("../components/UserManualList.vue"),      
},
{
  path: "/userManualEditList",
  name: "UserManualEditList",
  props: true,
  meta: {
    title: 'UserManualEditList',
    requiresAuth: true,
    is_admin: true,
    is_scsi:true
   
  },
  component: () => import("../components/UserManualEditList.vue"),      
},


{
  path: "/userManualView/:id",
  name: "UserManualView",
  props: true,
  meta: {
    title: 'UserManualView',
    requiresAuth: true,
    is_compalUser: true,
    is_vendorUser: true
   
  },
  component: () => import("../components/UserManualView.vue"),      
},

{
  path: "/DeleteLogReport_Supervisor_DeleteMFGVendorCode",
  name: "DeleteLogReport_Supervisor_DeleteMFGVendorCode",
  props: true,
  meta: {
    title: 'DeleteLogReport_Supervisor_DeleteMFGVendorCode',
    requiresAuth: true,
    is_scsi:true 
   
  },
  component: () => import("../components/DeleteLogReport_Supervisor_DeleteMFGVendorCode.vue"),      
},

{
  path: "/DeleteLogReport_Supervisor_DeleteSystem",
  name: "DeleteLogReport_Supervisor_DeleteSystem",
  props: true,
  meta: {
    title: 'DeleteLogReport_Supervisor_DeleteSystem',
    requiresAuth: true,
    is_scsi:true 
   
  },
  component: () => import("../components/DeleteLogReport_Supervisor_DeleteSystem.vue"),      
},
{
  path: "/DeleteLogReport_Supervisor_DeleteUser",
  name: "DeleteLogReport_Supervisor_DeleteUser",
  props: true,
  meta: {
    title: 'DeleteLogReport_Supervisor_DeleteUser',
    requiresAuth: true,
    is_scsi:true 
   
  },
  component: () => import("../components/DeleteLogReport_Supervisor_DeleteUser.vue"),      
},
{
  path: "/DeleteLogReport_SCSI_ChangeSourcer",
  name: "DeleteLogReport_SCSI_ChangeSourcer",
  props: true,
  meta: {
    title: 'DeleteLogReport_SCSI_ChangeSourcer',
    requiresAuth: true,
    is_scsi:true 
   
  },
  component: () => import("../components/DeleteLogReport_SCSI_ChangeSourcer.vue"),      
},
{
  path: "/DeleteLogReport_SCSI_DeleteSearchTerm",
  name: "DeleteLogReport_SCSI_DeleteSearchTerm",
  props: true,
  meta: {
    title: 'DeleteLogReport_SCSI_DeleteSearchTerm',
    requiresAuth: true,
    is_scsi:true 
   
  },
  component: () => import("../components/DeleteLogReport_SCSI_DeleteSearchTerm.vue"),      
},
{
  path: "/DeleteLogReport_SCSI_DeleteSupervisor",
  name: "DeleteLogReport_SCSI_DeleteSupervisor",
  props: true,
  meta: {
    title: 'DeleteLogReport_SCSI_DeleteSupervisor',
    requiresAuth: true,
    is_scsi:true 
   
  },
  component: () => import("../components/DeleteLogReport_SCSI_DeleteSupervisor.vue"),      
},
{
  path: "/DeleteLogReport_Sourcer_CancelMFGCode",
  name: "DeleteLogReport_Sourcer_CancelMFGCode",
  props: true,
  meta: {
    title: 'DeleteLogReport_Sourcer_CancelMFGCode',
    requiresAuth: true,
    is_scsi:true,
    is_source: true
   
  },
  component: () => import("../components/DeleteLogReport_Sourcer_CancelMFGCode.vue"),      
},

{
  path: "/scsiMaillogList",
  name: "SCSIMaillogList",
  meta: {
    title: 'SCSIMaillogList',
    requiresAuth: true,
    is_scsi:true
    
  },
  component: () => import("../components/SCSIMaillogList.vue"),
},
{
  path: "/scsiUpdateSupervisorSAPSearchTerm",
  name: "SCSIUpdateSupervisorSAPSearchTerm",
  meta: {
    title: 'SCSIUpdateSupervisorSAPSearchTerm',
    requiresAuth: true,
    is_scsi:true
    
  },
  component: () => import("../components/SCSIUpdateSupervisorSAPSearchTerm.vue"),
},





     {
        path: "/login",
        name: "login",
        meta: {
          title: '登入',
        },
        component: () => import("../components/Login.vue"),
      }, 
      {
        path: "/logout",
        name: "logout",
        meta: {
          title: 'logout',
        },
        component: () => import("../components/Logout.vue"),
      }, 
      {
        path: "/unAuthorization",
        name: "UnAuthorization",
        meta: {
          title: 'UnAuthorization',
        },
        component: () => import("../components/UnAuthorization.vue"),
      }, 
      {
        path: "/systempage",
        name: "systempage",
        meta: {
            title: 'SystemPage',
        },
        component: () => import("../components/SystemPage.vue"),
    },

    {
      path: "/ocr",
      name: "ocr",
      meta: {
          title: 'OCR',
      },
      component: () => import("../components/OCR.vue"),
  },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
  });
  

  router.beforeEach(to => {
    
     if (to.matched.some(reocrd => reocrd.meta.requiresAuth)) 
    {
      //if (store.state.token) 
      if (sessionStorage.getItem("vip_token")) 
       {
        //let roles = store.state.user?.Roles;
        let user = JSON.parse(sessionStorage.getItem("user"))
        let roles  = user?.Roles;
        //
        //let roles = store.state.user?.Roles;
        if (to.matched.some(reocrd => reocrd.meta.is_scsi) && roles && roles.includes('SCSI'))
        {
            return true;
        }
        else if (to.matched.some(reocrd => reocrd.meta.is_admin) && roles && roles.includes('VIPAdmin'))
        {
            return true;
        }
        else if (to.matched.some(reocrd => reocrd.meta.is_source) && roles && roles.includes('Sourcer'))
        {
              return true;
        }
        else if (to.matched.some(reocrd => reocrd.meta.is_buyer) && roles && roles.includes('Buyer'))
        {
              return true;
        }
        else if (to.matched.some(reocrd => reocrd.meta.is_compalUser) && roles && roles.includes('CompalUser'))
        {
             return true;
        }
        else if (to.matched.some(reocrd => reocrd.meta.is_supervisor) && roles && roles.includes('Supervisor'))
        {
            return true;
        }
        else if (to.matched.some(reocrd => reocrd.meta.is_vendorUser) && roles && roles.includes('VendorUser'))
        {
            return true;
         }
        else {
          return {
            path: '/unAuthorization',
            query: { redirect: to.fullPath }
          }
        }
      
      }
      else {
        return {
          path: '/login',
          query: { redirect: to.fullPath }
        }
      } 
  
    }
    else {
      return true;
    } 
    
  
  })
  
  
  
  export default router;